module.exports = __webpack_public_path__ + "static/media/Matlandia7_przewodnik_po_zadaniach.ef0f68d9.pdf";